import Entity from '../entity'

export default class HzLetterDatas extends Entity<number>{
    projectName:string;
    sendWay:string="";
    letterData:Array<any>=[];
}